export default __webpack_public_path__ + "static/media/zebec.ee6fdaea.png";